exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-data-driven-js": () => import("./../../../src/pages/data-driven.js" /* webpackChunkName: "component---src-pages-data-driven-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-visualize-js": () => import("./../../../src/pages/visualize.js" /* webpackChunkName: "component---src-pages-visualize-js" */)
}

